/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */


const theme = {
  appearances: {
    danger: {
      description: 'Indicates a user action that is destructive and will result in loss of information or cause significant monetary charges. Limit the use of the danger button whenever possible.',
      type: 'variant',
      values: [ true ]
    },
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    inactive: {
      description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
      type: 'state',
      values: [ true ]
    },
    inverse: {
      description: 'Use inverse buttons on darker backgrounds. High and low priority buttons, and danger buttons, are available in inverse.',
      type: 'variant',
      values: [ true ]
    },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    },
    priority: {
      description: 'Indicates the importance of the call-to-action. Limit the amount of high priority buttons on a page to prioritize meaningful user flows. Low priority styles are applied by default.',
      type: 'variant',
      values: [ 'high', 'low' ]
    },
    size: { type: 'variant', values: [ 'small' ] },
    text: {
      description: 'Text variant visually deprioritize the button styles',
      type: 'variant',
      values: [ true ]
    },
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    },
    width: {
      description: 'Available in default, full-width or responsive. Default-width expands based on content. Full-width expands to width of the container. Responsive automatically applies full-width when is displayed on the XS viewport.',
      type: 'variant',
      values: [ 'full', 'responsive' ]
    }
  },
  rules: [
    {
      if: { hover: true },
      tokens: {
        borderBottomWidth: 3,
        borderLeftWidth: 3,
        borderRightWidth: 3,
        borderTopWidth: 3
      }
    },
    {
      if: { priority: 'high' },
      tokens: {
        backgroundColor: '#2b8000',
        borderColor: 'rgba(0, 0, 0, 0)',
        borderWidth: 0,
        color: '#ffffff'
      }
    },
    {
      if: { pressed: true },
      tokens: {
        backgroundColor: '#163e06',
        borderColor: 'rgba(0, 0, 0, 0)',
        color: '#ffffff'
      }
    },
    { if: { focus: true }, tokens: { outerBorderColor: '#2b8000' } },
    {
      if: { inverse: true },
      tokens: {
        backgroundColor: null,
        borderColor: '#ffffff',
        color: '#ffffff'
      }
    },
    {
      if: { hover: true, priority: 'high' },
      tokens: { backgroundColor: '#1f5c09' }
    },
    {
      if: { focus: true, pressed: true },
      tokens: { outerBorderColor: '#163e06' }
    },
    {
      if: { inverse: true, priority: 'high' },
      tokens: { backgroundColor: '#ffffff', color: '#414547' }
    },
    {
      if: { hover: true, inverse: true, priority: 'high' },
      tokens: { backgroundColor: 'rgba(255, 255, 255, 0.8)' }
    },
    {
      if: { inverse: true, pressed: true },
      tokens: {
        backgroundColor: 'rgba(255, 255, 255, 0.6)',
        borderColor: 'rgba(0, 0, 0, 0)',
        color: '#414547'
      }
    },
    {
      if: { focus: true, inverse: true },
      tokens: { outerBorderColor: '#ffffff' }
    },
    {
      if: { danger: true, priority: null },
      tokens: { borderColor: '#e12339', color: '#e12339' }
    },
    {
      if: { danger: true, inverse: true, priority: null },
      tokens: { backgroundColor: '#ffffff' }
    },
    {
      if: { danger: true, focus: true, priority: null },
      tokens: { outerBorderColor: '#e12339' }
    },
    {
      if: { danger: true, pressed: true, priority: null },
      tokens: {
        backgroundColor: '#c12335',
        borderColor: 'rgba(0, 0, 0, 0)',
        color: '#ffffff'
      }
    },
    {
      if: { danger: true, focus: true, pressed: true, priority: null },
      tokens: { outerBorderColor: '#c12335' }
    },
    { if: { width: 'full' }, tokens: { width: '100%' } },
    {
      if: { viewport: [ 'xs' ], width: 'responsive' },
      tokens: { width: '100%' }
    },
    {
      if: { size: 'small' },
      tokens: { minWidth: 0, paddingBottom: 4, paddingTop: 4 }
    },
    {
      description: 'Buttons should not be disabled or set as inactive. Use inline (on blur) error messaging to provide feedback when the form is invalid. In exceptional instances where disabled buttons are needed, it must be clear to the user why the button is disabled and what they need to do to enable it.',
      if: { inactive: true },
      tokens: {
        backgroundColor: '#b2b9bf',
        borderColor: 'rgba(0, 0, 0, 0)',
        borderWidth: 0,
        color: '#ffffff'
      }
    },
    {
      if: { inactive: true, inverse: true },
      tokens: {
        backgroundColor: 'rgba(255, 255, 255, 0.6)',
        borderColor: 'rgba(0, 0, 0, 0)',
        color: '#414547'
      }
    },
    {
      if: { text: true },
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0)',
        borderColor: 'rgba(0, 0, 0, 0)',
        borderLeftWidth: 0,
        borderRightWidth: 0,
        borderWidth: null,
        minWidth: 0,
        outerBorderColor: 'rgba(0, 0, 0, 0)',
        paddingLeft: 0,
        paddingRight: 0,
        textLine: 'underline'
      }
    },
    { if: { hover: true, text: true }, tokens: { textLine: 'none' } },
    {
      if: { priority: 'high', text: true },
      tokens: { color: '#2b8000' }
    },
    {
      if: { priority: 'low', text: true },
      tokens: { color: '#414547' }
    },
    {
      if: { focus: true, text: true },
      tokens: {
        borderColor: 'rgba(0, 0, 0, 0)',
        borderRadius: 0,
        color: '#2b8000',
        outerBorderColor: '#2b8000'
      }
    },
    {
      if: { hover: true, priority: 'high', text: true },
      tokens: { color: '#1f5c09' }
    },
    {
      if: { hover: true, priority: null, text: true },
      tokens: { color: '#1f5c09' }
    },
    {
      if: { hover: true, priority: 'low', text: true },
      tokens: { color: '#414547' }
    },
    {
      if: { danger: true, hover: true, text: true },
      tokens: { color: '#c12335' }
    },
    {
      if: { pressed: true, text: true },
      tokens: {
        borderColor: 'rgba(0, 0, 0, 0)',
        color: '#163e06',
        outerBorderColor: 'rgba(0, 0, 0, 0)',
        textLine: 'none'
      }
    },
    {
      if: { focus: true, pressed: true, text: true },
      tokens: {
        borderColor: 'rgba(0, 0, 0, 0)',
        color: '#163e06',
        outerBorderColor: '#163e06',
        textLine: 'none'
      }
    },
    {
      if: { inactive: true, text: true },
      tokens: {
        borderColor: 'rgba(0, 0, 0, 0)',
        color: '#b2b9bf',
        outerBorderColor: 'rgba(0, 0, 0, 0)',
        textLine: 'none'
      }
    },
    {
      if: { inverse: true, text: true },
      tokens: { borderRadius: 0, color: '#ffffff' }
    },
    {
      if: { focus: true, inverse: true, text: true },
      tokens: { borderColor: 'rgba(0, 0, 0, 0)', outerBorderColor: '#ffffff' }
    },
    {
      if: { focus: true, inverse: true, pressed: true, text: true },
      tokens: {
        borderColor: 'rgba(0, 0, 0, 0)',
        color: '#b2b9bf',
        outerBorderColor: '#b2b9bf'
      }
    },
    {
      if: { inactive: true, inverse: true, text: true },
      tokens: {
        borderColor: 'rgba(0, 0, 0, 0)',
        color: '#b2b9bf',
        outerBorderColor: 'rgba(0, 0, 0, 0)'
      }
    }
  ],
  tokens: {
    backgroundColor: '#ffffff',
    borderBottomWidth: 1,
    borderColor: '#2b8000',
    borderLeftWidth: 1,
    borderRadius: 32,
    borderRightWidth: 1,
    borderTopWidth: 1,
    borderWidth: 1,
    color: '#2b8000',
    flex: 0,
    fontName: 'HNforTELUSSA',
    fontSize: 16,
    fontWeight: '700',
    height: null,
    icon: null,
    iconSize: 24,
    iconSpace: 1,
    lineHeight: 1.5,
    minWidth: 144,
    opacity: 1,
    outerBackgroundColor: 'rgba(0, 0, 0, 0)',
    outerBorderColor: 'rgba(0, 0, 0, 0)',
    outerBorderGap: 2,
    outerBorderWidth: 2,
    paddingBottom: 12,
    paddingLeft: 32,
    paddingRight: 32,
    paddingTop: 12,
    shadow: null,
    textAlign: 'center',
    textLine: 'none',
    textLineStyle: 'solid',
    width: null
  }
}
export default theme
